// extracted by mini-css-extract-plugin
export default {"warning":"alert_warning__UPIpy","success":"alert_success__vZp7m"};